import {
    Navigate,
    Outlet,
    useLocation,
} from "react-router-dom";

import {
    useSelector,
} from "react-redux";

import type {
    RootState,
} from "../store";

import { getRouteForPhase } from "../utils/journeyRouting";


const ProtectedRoute = () => {

    const token =
        useSelector(
            (state: RootState) =>
                state.auth.token
        );

    const journey =
        useSelector(
            (state: RootState) =>
                state.journey.journey
        );

    const location = useLocation();


    if (!token) {

        return (
            <Navigate
                to="/Nlogin"
                replace
            />
        );
    }


    if (!journey) {

        return (
            <Navigate
                to="/Nlogin"
                replace
            />
        );
    }


    /*
     * Phase guard: only allow this specific route if it
     * matches where the journey actually is. Prevents a
     * gateway customer from reaching /ndashboard (or any
     * other protected route) before their journey has
     * reached NATIVE, and prevents a merchant/completed
     * customer from being stuck on a pre-flow gateway
     * screen if they somehow land on one.
     */
    const expectedRoute = getRouteForPhase(journey.phase);

    if (location.pathname !== expectedRoute) {

        return (
            <Navigate
                to={expectedRoute}
                replace
            />
        );
    }


    return <Outlet />;
};


export default ProtectedRoute;